// extracted by mini-css-extract-plugin
module.exports = {"content":"WebChatAfterHoursMessageEvent_content__3YGE8","fullWidth":"WebChatAfterHoursMessageEvent_fullWidth__3MbCx","compact":"WebChatAfterHoursMessageEvent_compact__1nlxh"};